import instance from '@src/api/axios'
import { PartnershipConsultParams } from '../types'

export const wevPartnershipApis = {
  partnershipConsult: (data: PartnershipConsultParams) => instance.post('/v1/guest/partnership-inquiry', data),
}
